<template>
  <div>
    <section class="jumbotron jumbotron-bg text-center" id="content-bg">
      <div class="container">
        <h1 class="jumbotron-heading jumbo-shadow">Welcome to ParsableWeb</h1>
        <p class="lead text-muted lead-shadow lead-color">
          ParsableWeb lets you track websites and notify you when something changes.<br/>
          Sign up for free!
        <p>
          <router-link v-if="isAuthenticated()==true" to="/job" class="btn btn-primary btn-lg">Get Started</router-link>
          <router-link v-else to="/get-started" class="btn btn-lg btn-primary btn-lg">Get Started</router-link>
        </p>
      </div>
    </section>
    <main role="main" class="container text-center">
      <div class="card-deck">
        <div class="card">
          <!-- <img src="" class="card-img-top" alt="..."> -->
          <div class="card-body">
            <h5 class="card-title">Target multiple page elements</h5>
            <p class="card-text">Select multiple page elements, which allows you to define more advanced checks</p>
          </div>
        </div>
        <div class="card">
          <!-- <img src="" class="card-img-top" alt="..."> -->
          <div class="card-body">
            <h5 class="card-title">Expression language</h5>
            <p class="card-text">Use simple yet powerful expressions against selected content to notify you only if expression passes</p>
          </div>
        </div>
        <div class="card">
          <!-- <img src="" class="card-img-top" alt="..."> -->
          <div class="card-body">
            <h5 class="card-title">Extract text, numbers and images</h5>
            <p class="card-text">Choice of parsing selected page element as text, numeric values or images</p>
          </div>
        </div>
      </div>
      <br/>
      <br/>
      <h2 class="jumbotron-heading jumbo-shadow">Use Cases</h2>
      <div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">Track prices of products on ecommerce websites
            &nbsp;&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-currency-dollar" viewBox="0 0 16 16">
  <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>
</svg>
          </li>
          <li class="list-group-item">Get notified on any mentions of the keywords on blogs or news websites
            &nbsp;&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-layout-text-window" viewBox="0 0 16 16">
  <path d="M3 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/>
  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v1H1V2a1 1 0 0 1 1-1h12zm1 3v10a1 1 0 0 1-1 1h-2V4h3zm-4 0v11H2a1 1 0 0 1-1-1V4h10z"/>
</svg>
          </li>
          <li class="list-group-item">Verify there are no content issues with pages on your website
            &nbsp;&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-bug" viewBox="0 0 16 16">
  <path d="M4.355.522a.5.5 0 0 1 .623.333l.291.956A4.979 4.979 0 0 1 8 1c1.007 0 1.946.298 2.731.811l.29-.956a.5.5 0 1 1 .957.29l-.41 1.352A4.985 4.985 0 0 1 13 6h.5a.5.5 0 0 0 .5-.5V5a.5.5 0 0 1 1 0v.5A1.5 1.5 0 0 1 13.5 7H13v1h1.5a.5.5 0 0 1 0 1H13v1h.5a1.5 1.5 0 0 1 1.5 1.5v.5a.5.5 0 1 1-1 0v-.5a.5.5 0 0 0-.5-.5H13a5 5 0 0 1-10 0h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 1 1-1 0v-.5A1.5 1.5 0 0 1 2.5 10H3V9H1.5a.5.5 0 0 1 0-1H3V7h-.5A1.5 1.5 0 0 1 1 5.5V5a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5H3c0-1.364.547-2.601 1.432-3.503l-.41-1.352a.5.5 0 0 1 .333-.623zM4 7v4a4 4 0 0 0 3.5 3.97V7H4zm4.5 0v7.97A4 4 0 0 0 12 11V7H8.5zM12 6a3.989 3.989 0 0 0-1.334-2.982A3.983 3.983 0 0 0 8 2a3.983 3.983 0 0 0-2.667 1.018A3.989 3.989 0 0 0 4 6h8z"/>
</svg>
          </li>
          <li class="list-group-item">Check travel websites for hot deals
            &nbsp;&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-signpost-split" viewBox="0 0 16 16">
  <path d="M7 7V1.414a1 1 0 0 1 2 0V2h5a1 1 0 0 1 .8.4l.975 1.3a.5.5 0 0 1 0 .6L14.8 5.6a1 1 0 0 1-.8.4H9v10H7v-5H2a1 1 0 0 1-.8-.4L.225 9.3a.5.5 0 0 1 0-.6L1.2 7.4A1 1 0 0 1 2 7h5zm1 3V8H2l-.75 1L2 10h6zm0-5h6l.75-1L14 3H8v2z"/>
</svg>
          </li>
        </ul>
      </div>
      <br/>
      <div>
        <p>
          <router-link v-if="isAuthenticated()==true" to="/job" class="btn btn-primary btn-lg">Try it Out!</router-link>
          <router-link v-else to="/get-started" class="btn btn-lg btn-primary btn-lg">Try it Out!</router-link>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  },
  methods: {
    isAuthenticated() {
      if (this.$parent.authenticated) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style scoped>
.jumbotron-bg {
  background: linear-gradient(rgba(255, 245, 235, 0.75)), url("https://content.parsableweb.com/bg-pattern.png") repeat center center;
  background-size: cover;
  background-position-y: 60px;
  background-size: 600px;
  
  /* background-position-y: -150px; */
  /* background-repeat: repeat; */
}
.jumbo-shadow {
  text-shadow: 1px 1px 5px rgba(255, 255, 255, 0.4);
}
.lead-shadow {
}
.lead-color {
}

</style>